import type { ServerConfig } from '@/@types';

export const serverConfig: ServerConfig = {
  subject: '测试环境',
  environment: 'test',
  apiSrc: 'https://saas-api1.pdaia.cn',
  questionarySrc: 'https://que-design-lite1.pdaia.cn',
};
